import React, {useState} from 'react';
import {Dropzone as MantineDropzone} from '@mantine/dropzone';
import {ImFilePicture} from 'react-icons/im';

import {VideoPreview} from './styles';
import {Group, Text} from '@mantine/core';

interface DropzoneProps {
  placeholder: string;
  accept: string[];
  type?: 'video' | 'image';
  fileValue?: File[];
  onChange?: (e: File[]) => void;
}

enum FILE_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
}

const Dropzone: React.FC<DropzoneProps> = ({
  accept,
  onChange,
  placeholder,
  type,
  fileValue,
}) => {
  const [file, setFile] = useState<File[]>(fileValue || []);

  return (
    <MantineDropzone
      accept={accept}
      onDrop={(files) => {
        setFile([...file, ...files]);
        onChange && onChange([...file, ...files]);
      }}>
      <Group
        align="center"
        gap="xl"
        style={{minHeight: 220, pointerEvents: 'none'}}>
        <MantineDropzone.Accept>
          {file.length > 0 && type === FILE_TYPE.IMAGE && (
            <img src={URL.createObjectURL(file[0])} width={300} height={300} />
          )}
          {file.length > 0 && type === FILE_TYPE.VIDEO && (
            <VideoPreview>
              <source src={file && URL.createObjectURL(file[0])} />
            </VideoPreview>
          )}
        </MantineDropzone.Accept>
        <MantineDropzone.Idle>
          <Group align="center" gap="sm">
            <ImFilePicture size={36} color="gray" />
            <Text size="xl" color="dimmed" inline>
              {placeholder}
            </Text>
          </Group>
        </MantineDropzone.Idle>
      </Group>
    </MantineDropzone>
  );
};

export default Dropzone;
